// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-largeOnConfined-text-56bb7f20"};